import React, { useEffect, useRef, useState } from "react";
import axios from 'axios';
import {
    TWITCH_OAUTH_URL, TWITCH_CLIENT_ID,
    REDIRECT_URI, TWITCH_SECRET,    
} from '../constants/twitchConstants';
import { loginUser } from "../utils/loginHelper";

const backendTwitchURL = 'https://be.namasteapis.com/twitch/v1';

export const axiosCall = (route) => {
  console.log('request:- ' + JSON.stringify(route));
  return new Promise(async (resolve, reject) => {
    return axios(route)
      .then((res) => {
        //console.log('Response:- ' + JSON.stringify(res));
        resolve(res);
      })
      .catch((error) => {
        //console.log('error:- ' + error);
        reject(error.response);
      });
  });
};

export function setTokenOnAxios(accessToken: string, bearer: boolean) {
    if (bearer) {
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    }
    else {
        axios.defaults.headers.common.Authorization = `Token ${accessToken}`;
    }
}

export async function sendTwitchTokenRequest(authCode: string) {
    let twitchTokenURL = `https://id.twitch.tv/oauth2/token?client_id=${TWITCH_CLIENT_ID}&client_secret=${TWITCH_SECRET}&code=${authCode}&grant_type=authorization_code&redirect_uri=${REDIRECT_URI}`;
    let resp = await axios.post(twitchTokenURL);
    if (resp.data) {return resp.data.access_token;}
    else {return;}
}

export async function fetchTwitchUserDetails(accessToken: string,) {
    let resp;
    setTokenOnAxios(accessToken, true);    
    try {
        resp = await axios.get(
            'https://api.twitch.tv/helix/users', {
            headers: {
                'Client-Id': TWITCH_CLIENT_ID,
            }
        });
        return resp.data;

    }
    catch (e) {
        console.log(e);
        return undefined;
    }
}

export async function loginAPI(twitchUser: any, socketId:any) {
    //twitchUser.data[0]['publicKey']= socketId;
    twitchUser.data[0]['socketId']= socketId;
    const request = {
        method: 'POST',
        url: `${backendTwitchURL}/oauth/?web=true`,
        'data': twitchUser
    };
    let res = await axiosCall(request);
    console.log('loginAPI', JSON.stringify(res));
    console.log(res.data.success);
    if (res.data.success) {
        return res.data;
    }
    else {
        return;
    }
}

export default function TwitchSuccessLoginComponent(props) {
    
    useEffect(()=>{
        (async ()=>{
            const urlSearchParams = new URLSearchParams(
                window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            let code = params['code'];
            let socketId = params['state'];
            let accessToken = await sendTwitchTokenRequest(code);
            let twitchData = await fetchTwitchUserDetails(accessToken);
            let loginData = await loginAPI(twitchData, socketId);
            if(socketId.includes('oldURL')){
                const myArray = socketId.split("oldURL-");
                loginUser(loginData)
                let oldURL = myArray[1];
                window.location.replace(oldURL);
                return;
            }
	    window.close();
        })();
    },[]);
    
    return (<></>);
}
